// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1upWW","type":"styles_type__1W-LK","choices":"styles_choices__2cOWa"};